import React from "react";
import Slider from "react-slick";
import Explore1 from '../../assets/images/explore1.png'
import Explore2 from '../../assets/images/explore2.png'
import Explore3 from '../../assets/images/explore3.png'
import Explore4 from '../../assets/images/explore4.png'
import Explore5 from '../../assets/images/explore5.png'
import Explore6 from '../../assets/images/explore6.png'
import Explore7 from '../../assets/images/explore7.png'
import Explore8 from '../../assets/images/explore8.png'

function Explore() {
    const explore = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 1,
        centerMode: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            }

        ]
    };
    const explore2 = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 1,
        centerMode: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            }

        ]
    };
    return (
        <section className="explore-category section-margin">
            <div className="container-fluid p-0">
                <div className="heading text-left main-padding">
                    <h2>Explore Our Amazing<br /> Top Categories.</h2>
                </div>
                <Slider className="explore" {...explore}>
                    <div className="item">
                        <div className="image">
                            <img src={Explore1} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>All NFTs</h3>
                            </a>

                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore2} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Art</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore3} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Music</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore4} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Virtual Worlds</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore1} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>All NFTs</h3>
                            </a>
                        </div>
                    </div>

                </Slider>
                <Slider className="explore second" {...explore2}>
                    <div className="item">
                        <div className="image">
                            <img src={Explore5} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Domain Names</h3>
                            </a>

                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore6} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Trading Cards</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore7} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Collectibles</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore8} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Sports</h3>
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src={Explore5} alt="" className="img-fluid" />
                        </div>
                        <div className="item-content">
                            <a href="#">
                                <h3>Domain Names</h3>
                            </a>
                        </div>
                    </div>

                </Slider>
            </div>
        </section>
    )
}
export default Explore;